import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Menu, Space, Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import moment from "moment";
import "moment/locale/th";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const EmployeeEmploymentShiftTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onDelete = () => { },
  onChange = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const columns = [
    {
      title: <div className="text-table">{t("employeeShift.table.no")}</div>,
      dataIndex: "no",
      key: "no",
      align: "center",
      render: (_, record, idx) => {
        return (
          <span
            style={{
              color: "#313131",
              backgroundColor: "#F5F6F7",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
            }}
          >
            {(pagination.page) * pagination.size + idx + 1}
          </span>
        )
      },
    },
    {
      title: <div className="text-table">{t("employeeShift.table.workSchedule")}</div>,
      dataIndex: "shiftId",
      key: "shiftId",
      render: (_, record) => {
        return i18n.language === "en" ? record?.shiftId?.nameEn : record?.shiftId?.name;
      },
    },
    {
      title: <div className="text-table">{t("employeeShift.table.effectiveDate")}</div>,
      dataIndex: "effectiveDate",
      sorter: (a, b) => moment(a.startDate).isAfter(moment(b.startDate)) ? 1 : -1,
      key: "startDate",
      render: (_, record) => {
        const { startDate } = record;
        return (
          <>
            {startDate ? dayjs(startDate).format("DD/MM/" + (i18n.language === "en" ? "YYYY" : "BBBB")) : "-"}
          </>
        );
      },
    },
    {
      title: <div className="text-table">{t("employeeShift.table.lastModified")}</div>,
      dataIndex: "lastModified",
      key: "updateBy",
      render: (_, record) => {
        const { updateDate, updateBy, createBy, createDate } = record;
        const last = updateBy ? updateBy : createBy;
        const name = i18n.language === "en" ? last?.nameEn + " " + last?.surNameEn : last?.name + " " + last?.surName;
        if (updateDate || createDate)
          return (
            <>
              {name}
              <br />
              {updateDate ? dayjs(updateDate).format("DD/MM/" + (i18n.language === "en" ? "YYYY" : "BBBB") + " HH:mm:ss") : dayjs(createDate).format("DD/MM/" + (i18n.language === "en" ? "YYYY" : "BBBB") + " HH:mm:ss")}
            </>
          );
      },
    },
    roles.includes("UPDATE_EMPLOYEE|EMPLOYMENT|SHIFT_INFO") ||
      roles.includes("DELETE_EMPLOYEE|EMPLOYMENT|SHIFT_INFO") ? {
      title: "",
      key: "action",
      align: "center",
      width: "10%",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            overlay={
              <Menu>
                {
                  roles.includes("UPDATE_EMPLOYEE|EMPLOYMENT|SHIFT_INFO") &&
                  <Menu.Item key="1" onClick={() => onEdit({
                    timePlanShiftId: record?.id,
                    shiftId: record?.shiftId?.id,
                    startDate: record?.startDate,
                    employeeId: record?.createBy?.id,
                  })}>
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                    <span style={{ marginLeft: "5px" }}>{t("action.edit")}</span>
                  </Menu.Item>
                }
                {
                  roles.includes("DELETE_EMPLOYEE|EMPLOYMENT|SHIFT_INFO") &&
                  <Menu.Item key="2" onClick={() => onDelete(record.id)}>
                    <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
                    <span style={{ marginLeft: "5px" }}>{t("action.delete")}</span>
                  </Menu.Item>
                }

              </Menu>
            }
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    } : {},
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
    />
  );
};

export default EmployeeEmploymentShiftTable;
